import React from "react";
interface props {
  className?: string;
}

function HandCoinsAboutus({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      fill="none"
      className={className}
      viewBox="0 0 60 60"
    >
      <g fill="#5D5FEF" clipPath="url(#clip0_327_23218)">
        <path
          d="M3.75 35.624h7.5V48.75h-7.5a1.875 1.875 0 01-1.875-1.875V37.5a1.875 1.875 0 011.875-1.875zm44.063-22.5c-.974 0-1.934.218-2.813.635a6.562 6.562 0 10-3.75 6.23 6.563 6.563 0 106.563-6.865z"
          opacity="0.2"
        ></path>
        <path d="M53.984 33.06a5.725 5.725 0 00-4.979-.99L39.2 34.323a6.561 6.561 0 00-6.386-8.074H21.08a7.456 7.456 0 00-5.304 2.196l-5.302 5.304H3.75A3.75 3.75 0 000 37.5v9.375a3.75 3.75 0 003.75 3.75h24.375c.153 0 .306-.019.455-.056l15-3.75c.095-.023.189-.054.279-.094l9.11-3.877.103-.046a5.765 5.765 0 00.921-9.741h-.01zM3.75 37.5h5.625v9.375H3.75V37.5zm47.679 1.924l-8.906 3.792-14.632 3.659H13.125V36.401l5.304-5.302A3.719 3.719 0 0121.079 30h11.733a2.812 2.812 0 110 5.625H26.25a1.875 1.875 0 100 3.75h7.5c.141 0 .282-.016.42-.047l15.703-3.612.072-.018a2.015 2.015 0 011.477 3.726h.007zM38.437 22.5a8.44 8.44 0 001.383-.113 8.437 8.437 0 106.614-11.015A8.438 8.438 0 1038.438 22.5zM52.5 19.687a4.687 4.687 0 11-9.374 0 4.687 4.687 0 019.374 0zM38.437 9.376a4.688 4.688 0 014.512 3.424 8.438 8.438 0 00-3.515 5.843 4.688 4.688 0 11-.996-9.267z"></path>
      </g>
      <defs>
        <clipPath id="clip0_327_23218">
          <path fill="#fff" d="M0 0H60V60H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export default HandCoinsAboutus;
